import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: '10rem',
    maxHeight: '10rem',
    minHeight: '10rem',
    margin: 0,
    padding: '1rem',
    backgroundColor: '#FFFFFF',
    gap: '0.875rem',
    borderRadius: '0.5rem',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    transition: 'all 300ms ease',

    '&:hover': {
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
    },
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& h2': {
      padding: 0,
      margin: 0,
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '1.25rem',
      lineHeight: '2rem',
      color: '#191C1A',
    },
  },

  footer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },

  item: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.125rem',

    '& p': {
      margin: 0,
      padding: 0,
      fontFamily: 'Nunito',
      fontWeight: '400',
      fontSize: '1rem',
      lineHeight: '1.5rem',
      color: '#000000',
      marginBottom: '0.25rem',
    },
  },

  connectorsBox: {
    display: 'flex',
    flexDirection: 'row',
  },
}))

export { useStyles }
